import { createRouter, createWebHashHistory,createWebHistory } from 'vue-router'
// import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
    meta: {
      title:"河马广告Hippoads",
    },
  },
  {
    path: '/fromList',
    name: 'list',
    component: () => import('../views/ListA.vue'),
    meta: {
      title:"河马广告Hippoads",
    },
  },
  {//路由重定向，当用户在页面上恶意输入，跳转到首页
    path: '/:i',
    name: 'homep',
    component: () => import('../views/HomeView.vue'),
    meta: {
      title:"河马广告Hippoads",
    },
  },
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  // }
]



const router = createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),//
  routes
})


export default router
